// libraries
import {RFValue} from 'react-native-responsive-fontsize';

const colorsTheme = (darkMode: 'light' | 'dark') => ({
  backgroundColor: darkMode === 'dark' ? '#21262F' : '#FFFFFF',
  text: '#6A717E',
  backgroundInput: darkMode === 'dark' ? '#2B313C' : '#F4F4F4',
  backgroundLogout: darkMode === 'dark' ? '#353B46' : '#E4E4E4',
  white: darkMode === 'dark' ? '#FFFFFF' : '#2B313C',
  mainText: darkMode === 'dark' ? '#F6D658' : '#6A717E',
  main: {
    [700]: '#F6D658',
    [800]: '#C3A73F',
  },
  black: {
    [100]: 'rgba(0,0,0,0.5)',
    [500]: '#303030',
    [700]: '#222222',
    [1000]: '#000000',
  },
  green: {
    [500]: '#84EBD8',
    [600]: '#3D898D',
    [700]: '#64ba64',
    [800]: '#39664B',
    [900]: '#59AD80',
  },
  blue: {
    [300]: '#81b0ff',
    [400]: '#31304D',
    [500]: '#161A30',
    [700]: '#3B5998',
  },
  gradient: {
    start: '#31304D',
    end: '#161A30',
  },
  gray: {
    [50]: '#F4F5F7',
    [150]: '#CECECE',
    [200]: '#F2F2F4',
    [250]: '#E4E4E4',
    [300]: '#C8C8C8',
    [400]: '#ADB5BD',
    [500]: '#757575',
    [600]: '#6A6A6A',
    [650]: '#353B46',
    [700]: '#32325D',
    [800]: '#727A89',
  },
  red: {
    [400]: '#CF4F5F',
    [500]: '#FE6264',
    [600]: '#E14253',
  },
  yellow: {
    [700]: '#FFD700',
  },
});

export default {
  colors: colorsTheme,
  fonts: {
    size: {
      8: `${RFValue(8)}px`,
      9: `${RFValue(9)}px`,
      10: `${RFValue(10)}px`,
      12: `${RFValue(12)}px`,
      14: `${RFValue(14)}px`,
      15: `${RFValue(15)}px`,
      16: `${RFValue(16)}px`,
      18: `${RFValue(18)}px`,
      20: `${RFValue(20)}px`,
      22: `${RFValue(22)}px`,
      24: `${RFValue(24)}px`,
      26: `${RFValue(26)}px`,
      30: `${RFValue(30)}px`,
      32: `${RFValue(32)}px`,
      60: `${RFValue(60)}px`,
      // 8: '8px',
      // 9: '9px',
      // 10: '10px',
      // 12: '12px',
      // 14: '14px',
      // 15: '15px',
      // 16: '16px',
      // 18: '18px',
      // 20: '20px',
      // 22: '22px',
      // 24: '24px',
      // 26: '26px',
      // 30: '30px',
      // 32: '32px',
      // 60: '60px',
    },
    family: {
      opensans: {
        bold: 'OpenSans-Bold',
        bold_italic: 'OpenSans-BoldItalic',
        extra_bold: 'OpenSans-ExtraBold',
        extra_bold_italic: 'OpenSans-ExtraBoldItalic',
        extra_italic: 'OpenSans-Italic',
        extra_light: 'OpenSans-Light',
        extra_light_italic: 'OpenSans-LightItalic',
        medium: 'OpenSans-Medium',
        medium_italic: 'OpenSans-MediumItalic',
        regular: 'OpenSans-Regular',
        semi_bold: 'OpenSans-SemiBold',
        semi_bold_italic: 'OpenSans-SemiBoldItalic',
      },
    },
  },
};
